import type { InjectionKey, Ref } from "vue";

export interface BudgetLeaveApi {
  confirmDiscard: () => Promise<boolean>;
  allowNextUnload: () => void;
}

export const BUDGET_LEAVE_KEY: InjectionKey<Ref<BudgetLeaveApi | null>> = Symbol("budgetLeave");
